






































































import {Emit} from 'vue-property-decorator';
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Achat, EssenceAchat, Livraison} from '@/models';

import storeLivraison from '@/stores/modules/livraison';
import CrudLivraisonListLivraison from "@/components/Crud/Livraison/ListLivraison.vue";
import CrudLivraisonEditDialog from "@/components/Crud/Livraison/EditDialog.vue";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import storeAchat from "@/stores/modules/achat";
import {Stored} from "vue-stored-prop-decorator/index";

@Component({
	components: {
		CrudLivraisonListLivraison,
		CrudLivraisonEditDialog,
		CrudDeleteDialog,
	}
})
export default class CrudLivraisonListLivraisonDialog extends Vue {
	@Stored(() => storeAchat)
		private achat: Achat;
	@InOut({ type: EssenceAchat  , isVModel: true }) private value!: EssenceAchat;

	private editLivraison: Livraison = null;
	private deletedLivraison: Livraison = null;
	private storeLivraison = storeLivraison;

	@Emit()
	private onSubmit() {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}


}
